// @flow
import { post, get } from './common';
import type { Address } from '../actions/types';

export const fetchDeliveryAddress = async (mobile: string, imei: string = '', session: string = '') => {
	try {
		const res = await get(
			'/customer/app/v2/getDeliveryAddress',
			{
				user_id: mobile,
			},
			{ session }
		);
		const { status = false, msg } = res;
		if (!status) {
			throw new Error(msg || 'Error while saving address');
		}
		return res;
	} catch (error) {
		throw error;
	}
};

export const saveDeliveryAddress = async (
	{ address = {}, mobile, imei }: { address: Address, mobile: string, imei: string },
	session: string = ''
) => {
	try {
		const res = await post(
			'/customer/app/saveDeliveryAddress',
			{
				user_id: mobile,
				address: address.address,
				flat_building: address.flat_building,
				label: address.label,
				id: address.id,
				geocode: address.geocode,
				imei,
			},
			{ session }
		);
		const { status = false, msg } = res;
		if (!status) {
			throw new Error(msg || 'Error while saving address');
		}
		return res;
	} catch (error) {
		throw error;
	}
};
